export var MessageDeliveryStatusEnum;
(function (MessageDeliveryStatusEnum) {
    MessageDeliveryStatusEnum["DELIVERED"] = "delivered";
    MessageDeliveryStatusEnum["BOUNCED"] = "bounced";
    MessageDeliveryStatusEnum["COMPLAINT"] = "complaint";
    MessageDeliveryStatusEnum["UNSUBSCRIBED"] = "unsubscribed";
    // Step never reached SES at all - filtered out by a subscriber/workflow preference
    // (e.g. subscriber disabled the email channel), not an SES-reported outcome.
    MessageDeliveryStatusEnum["CANCELED"] = "canceled";
})(MessageDeliveryStatusEnum || (MessageDeliveryStatusEnum = {}));
//# sourceMappingURL=delivery-status.js.map